// extracted by mini-css-extract-plugin
export var formInfo = "fz_MJ";
export var formInfo__image = "fz_MC";
export var formInfo__link = "fz_MH";
export var formInfo__list = "fz_MF";
export var formInfo__sectionHr = "fz_MG";
export var formInfo__services = "fz_MB";
export var formInfo__title = "fz_MD";